/**
 * 系统管理  线路列表
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>线路列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="serviceName"
          placeholder="输入服务名称"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="">
        <el-input size="small" v-model="formInline.roleNo" placeholder="输入角色代码"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleEdit()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listDataFilter"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column align="center" prop="id" label="ID"> </el-table-column>
      <el-table-column align="center" prop="serviceName" label="服务名称">
      </el-table-column>
      <el-table-column align="center" prop="lineName" label="线路名称">
      </el-table-column>
      <el-table-column align="center" prop="provider" label="运营商">
      </el-table-column>
      <el-table-column align="center" prop="type" label="会员类型">
        <template slot-scope="scope">
          <div>{{ scope.row.type == 1 ? "vip" : "svip" }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态">
        <template slot-scope="scope">
          <div>{{ scope.row.status == 0 ? "无效" : "运行" }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="areaName" label="地区">
      </el-table-column>
      <el-table-column align="center" prop="ip" label="ip"> </el-table-column>
      <el-table-column
        align="center"
        label="操作"
        fixed="right"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleEdit(scope.$index, scope.row, 'add')"
            >添加</el-button
          >
          <!-- <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="editFormVisible"
      width="33%"
      @click="closeDialog('edit')"
    >
      <el-form
        label-width="150px"
        :model="editForm"
        ref="editForms"
        :rules="rules"
      >
        <el-form-item label="线路编码" prop="lineName">
          <el-input
            size="small"
            v-model="editForm.lineName"
            auto-complete="off"
            placeholder="请输入渠道"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="服务器名称"
          prop="serviceName"
          v-if="title == '添加' || title == '快速添加'"
        >
          <el-input
            size="small"
            v-model="editForm.serviceName"
            auto-complete="off"
            placeholder="请输入服务器名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="状态" prop="status">
          <el-select
            size="small"
            v-model="editForm.status"
            placeholder="请选择"
            class="userRole"
          >
            <el-option label="开启" :value="1"></el-option>
            <el-option label="关闭" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营商" prop="provider">
          <el-input
            size="small"
            v-model="editForm.provider"
            auto-complete="off"
            placeholder="请输入运营商"
          ></el-input>
        </el-form-item>
        <el-form-item label="省份" prop="areaId" v-if="title == '添加'">
          <el-select
            size="small"
            v-model="province"
            placeholder="请选择"
            class="userRole"
            @change="changePro()"
          >
            <el-option
              v-for="(item, index) in provinceData"
              :key="index"
              :label="item.areaName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="市区"
          prop="areaId"
          v-if="cityData.length != 0 && title == '添加'"
        >
          <el-select
            size="small"
            v-model="city"
            placeholder="请选择"
            class="userRole"
            @change="changeCity"
          >
            <el-option
              v-for="(item, index) in cityData"
              :key="index"
              :label="item.areaName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员类型" prop="type">
          <el-select
            size="small"
            v-model="editForm.type"
            placeholder="请选择"
            class="userRole"
          >
            <el-option label="vip" :value="1"></el-option>
            <el-option label="svip" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生成vpn配置文件" prop="createVpnFile">
          <el-select
            size="small"
            v-model="editForm.createVpnFile"
            placeholder="请选择"
            class="userRole"
            @change="changeCreateVpnFile()"
          >
            <el-option label="生成" :value="1"></el-option>
            <el-option label="不生成" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="vpn配置文件地址" prop="file">
          <el-input
            size="small"
            v-model="editForm.file"
            placeholder="请输入vpn配置文件地址"
          ></el-input>
        </el-form-item>

        <!-- createVpnFile -->
        <!-- <el-form-item label="服务名称" v-if="title=='修改'">
          <el-input size="small" v-model="editForm.serviceName" auto-complete="off" placeholder="请输入服务名称"></el-input>
        </el-form-item> -->
        <el-form-item label="vpn服务ip" prop="ip">
          <el-input
            size="small"
            v-model="editForm.ip"
            placeholder="请输入vpn服务ip"
          ></el-input>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input
            size="small"
            v-model="editForm.port"
            placeholder="端口号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForms')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  roleList,
  vpnLineUpdate,
  rolePwd,
  vpnAreaFirstList,
  vpnAreaSecendList,
  vpnLineAdd,
} from "../../api/userMG";
import { vpnLinePage } from "../../api/payMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      listDataFilter: [],
      serviceName: "",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: "添加",
      province: "",
      provinceData: [],
      cityData: [],
      city: "",
      editForm: {
        createVpnFile: "",
        port: null,
        areaId: "",
        file: "",
        type: "",
      },
      // rules 表单验证
      rules: {
        status: [{ required: true, message: "请输入状态", trigger: "blur" }],
        lineName: [
          { required: true, message: "请输入线路编码", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择会员类型", trigger: "blur" }],
        provider: [
          { required: true, message: "请输入运营商", trigger: "blur" },
        ],
        createVpnFile: [
          {
            required: true,
            message: "请选择是否生成vpn配置文件",
            trigger: "blur",
          },
        ],
        ip: [{ required: true, message: "请输入vpn服务ip", trigger: "blur" }],
        areaId: [{ required: true, message: "请选择省份", trigger: "blur" }],
        // port:[
        //   { required: true, message: "请输入端口号", trigger: "blur" },
        // ]
      },
      formInline: {
        pageNo: 0,
        pageSize: 10000,
        serviceName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: "children",
        label: "name",
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: "",
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取角色列表
    getdata(parameter) {
      // 模拟数据
      // let res = {
      //   code: 0,
      //   msg: null,
      //   count: 6,
      //   data: [
      //     {
      //       addUser: 'root',
      //       editUser: 'root',
      //       addTime: 1519182004000,
      //       editTime: 1520288426000,
      //       roleId: 1,
      //       systemNo: 'pmd',
      //       roleNo: 'Administrator',
      //       roleName: '超级管理员'
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1521111376000,
      //       editTime: 1520678191000,
      //       roleId: 2,
      //       systemNo: 'order',
      //       roleNo: 'admin',
      //       roleName: '地区列表员'
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1520678221000,
      //       editTime: 1520678221000,
      //       roleId: 95,
      //       systemNo: 'pm',
      //       roleNo: 'common',
      //       roleName: '普通用户'
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526349853000,
      //       editTime: 1526349853000,
      //       roleId: 96,
      //       systemNo: '1',
      //       roleNo: '1',
      //       roleName: '1'
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526349942000,
      //       editTime: 1526437443000,
      //       roleId: 97,
      //       systemNo: '2',
      //       roleNo: '2',
      //       roleName: '2'
      //     },
      //     {
      //       addUser: null,
      //       editUser: null,
      //       addTime: 1526652148000,
      //       editTime: 1526652148000,
      //       roleId: 101,
      //       systemNo: 'test',
      //       roleNo: 'demo',
      //       roleName: '演示角色'
      //     }
      //   ]
      // }
      vpnLinePage({ pageNo: 0, pageSize: 10000 }).then((res) => {
        this.listData = res.data.dataList;
        this.listDataFilter = res.data.dataList;
      });
      this.loading = false;
      vpnAreaFirstList({ id: 0 }).then((res) => {
        this.provinceData = res.data;
        console.log("省", res.data);
      });

      // 分页赋值
      // this.pageparm.currentPage = this.formInline.page
      // this.pageparm.pageSize = this.formInline.limit
      // this.pageparm.total = res.count
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // roleList(parameter)
      //   .then(res => {
      //     this.loading = false
      //     if (res.success == false) {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     } else {
      //       this.listData = res.data
      //       // 分页赋值
      //       this.pageparm.currentPage = this.formInline.page
      //       this.pageparm.pageSize = this.formInline.limit
      //       this.pageparm.total = res.count
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('获取角色列表失败，请稍后再试！')
      //   })
    },
    changePro() {
      this.city = "";
      vpnAreaSecendList({ id: this.province }).then((res) => {
        console.log(res.data);
        this.cityData = res.data;
      });
    },
    changeCreateVpnFile() {
      console.log(11111111111111111111);
      if (this.editForm.createVpnFile == 1) {
        this.editForm.port = 52115;
        // console.log('+++++++++++++')
        this.rules.file = [];
      } else {
        console.log("bushengcheng");
        // this.$set(this.rules.file, 0, { required: true, message: '不生成vpn配置文件需要手动填写', trigger: 'blur' });
        this.editForm.port = "";

        // 删除验证规则
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      if (this.serviceName) {
        this.listDataFilter = this.listData.filter((item) =>
          item.serviceName.includes(this.serviceName)
        );
      } else {
        this.listDataFilter = this.listData;
      }
    },
    //显示编辑界面
    handleEdit: function (index, row, type) {
      // $refs[editData]
      let that = this;

      this.editFormVisible = true;
      that.$nextTick(() => {
        that.$refs.editForms.resetFields();
        if (row) {
          this.title = "修改";
          console.log("row", row);
          this.editForm = JSON.parse(JSON.stringify(row));
        } else {
          this.title = "添加";
          this.editForm = {
            lineName: "",
            serviceName: "",
            status: "",
            type: "",
            createVpnFile: "",
            file: "",
            ip: "",
            port: "",
            areaId:''
          };

          this.city = "";
          this.province = "";
          // this.editForm.lineName = "";
          // this.editForm.serviceName = "";
          // this.editForm.status = "";
          // this.editForm.type = "";
          // this.editForm.createVpnFile = "";
          // this.editForm.file = "";
          // this.editForm.ip = "";
          // this.editForm.port = "";
        }
        if (type == "add") {
          this.title = "快速添加";
          this.city = "";
          this.province = "";
          this.editForm = JSON.parse(JSON.stringify(row));
          delete this.editForm.id;
        }
      });
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if (this.title == "添加") {
        if (this.city) {
          this.editForm.areaId = this.city;
        } else {
          this.editForm.areaId = this.province;
        }
      }
      this.$refs[editData].validate((valid) => {
        if (valid) {
          if (this.title == "修改") {
            console.log("编辑", this.editForm);
            vpnLineUpdate(this.editForm)
              .then((res) => {
                this.editFormVisible = false;
                this.loading = false;
                if (res.success) {
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "保存成功！",
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("保存失败，请稍后再试！");
              });
          } else {
            console.log("新曾", this.editForm);
            vpnLineAdd(this.editForm)
              .then((res) => {
                this.editFormVisible = false;
                this.loading = false;
                if (res.success) {
                  this.getdata(this.formInline);
                  this.$message({
                    type: "success",
                    message: "保存成功！",
                  });
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.editFormVisible = false;
                this.loading = false;
                this.$message.error("保存失败，请稍后再试！");
              });
          }
        } else {
          return false;
        }
      });
    },
    // 删除角色
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          roleDelete(row.roleId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "已删除！",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 数据权限
    menuAccess: function (index, row) {
      this.menuAccessshow = true;
      this.saveroleId = row.roleId;
      RoleRightTree(row.roleId)
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "获取权限成功",
            });
            this.changemenu(res.data.data);
            this.RoleRight = this.changeArr(res.data.data);
          } else {
            this.$message({
              type: "info",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取权限失败，请稍后再试！");
        });
    },
    // 选中菜单
    changemenu(arr) {
      let change = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id);
        }
      }
      this.checkmenu = change;
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = [];
      for (var i in list) {
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: [],
          };
          temptree[list[i].id] = trow;
          items.push(trow);
        }
        if (list[i].uid > 0) {
          temptree[list[i].id]["children"].push({
            id: list[i].id,
            pId: list[i].pId,
            name: list[i].name,
            open: list[i].open,
            checked: list[i].checked,
            children: [],
          });
        }
      }

      for (var j in items) {
        if (temptree[items[j].pId]) {
          temptree[items[j].pId]["children"].push(temptree[items[j].id]);
        } else {
          tree.push(temptree[items[j].id]);
        }
      }
      temptree = null;
      items = null;
      return tree;
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        roleId: this.saveroleId,
        moduleIds: "",
      };
      let node = this.$refs.tree.getCheckedNodes();
      let moduleIds = [];
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          moduleIds.push(node[i].id);
        }
        parm.moduleIds = JSON.stringify(moduleIds);
      }
      RoleRightSave(parm)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            this.menuAccessshow = false;
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("保存失败，请稍后再试！");
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == "edit") {
        this.editFormVisible = false;
      } else if (dialog == "perm") {
        this.menuAccessshow = false;
      }
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
/deep/ .el-form-item {
  margin-bottom: 10px !important;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/Role.vue